import { Component, Inject } from '@angular/core';
import { SubscriptionsFormComponent } from 'src/app/form/subscriptions/subscriptions.component';
import { ModalService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'wagtail-page-element-shop-newsletter',
    templateUrl: './shop-newsletter.component.html',
    styleUrls: ['./shop-newsletter.component.scss'],
    standalone: false
})
export class ShopNewsletterComponent {

  constructor(
    @Inject(ModalService) private modalService: ModalService,
  ) { }

  openSubscriptionsModal() {
    let modal = this.modalService.show(SubscriptionsFormComponent, {
      title: "Zum Newsletter anmelden",
      subscribers: {
        submitEvent: function() {
          modal.close()
        }
      }
    })
  }
}
